import authRoutes from "./authRoutes"
import otherRoutes from "./otherRoutes"

const routes = [
    ...authRoutes,
    ...otherRoutes
]

export default routes